/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const ShareIcon = createIcon(
  '0 0 20 20',
  <g>
    <path d="M7 10H5v6h10v-6h-2V8h4v10H3V8h4z" />
    <path d="M14 6h-3v7H9V6H6l4-6z" />
  </g>,
);
